var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeofenceAutoApproval(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B4B9",
    d: "M9.558 19.823l6.84-1.366.293 1.47-6.84 1.367-.293-1.471zM18.456 16.398l1.366-6.84 1.47.294-1.365 6.84-1.47-.294zM11.556 4.53l.557-1.393 7.08 2.835-.557 1.392-7.08-2.835zM3.943 8.325l3.75-4.155 1.114 1.005-3.75 4.155-1.114-1.005zM3.196 12.865l1.379-.592 2.73 6.36-1.379.592-2.73-6.36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M24 7.5c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3zM12.75 3c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3zM6 10.5c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3zM10.5 21c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3zM21.75 18.75c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 2.25h1.5v1.5H9v-1.5zM20.25 6.75h1.5v1.5h-1.5v-1.5zM18 18h1.5v1.5H18V18zM6.75 20.25h1.5v1.5h-1.5v-1.5zM2.25 9.75h1.5v1.5h-1.5v-1.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M15.468 9.262l-5.262 5.261-1.683-1.682c-.348-.349-.912-.349-1.261 0-.35.35-.35.913 0 1.262l2.317 2.318c.35.349.913.349 1.262 0l5.897-5.897c.35-.35.35-.913 0-1.262-.349-.35-.921-.35-1.27 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofenceAutoApproval);
export default __webpack_public_path__ + "static/media/geofence-auto-approval.817e4982.svg";
export { ForwardRef as ReactComponent };